
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91slug_93q0MUESNGWO_45HEv_y3s_45JLFqlTZyi_45xyMJd8zDt3QmpgMeta } from "/app/pages/activities/[slug].vue?macro=true";
import { default as index3IAlOUPjudokwLk5fHMNX_2ErptX4undnQbtukBLvLEMeta } from "/app/pages/activities/index.vue?macro=true";
import { default as authLldLAL6sjaJfinhufTblQ2SvXbV4tXp__siTwYISsSIMeta } from "/app/pages/auth.vue?macro=true";
import { default as formwPYOCSJJyn9PTueljwbcy_45Y7KFWJ5A2INxiIXRMXiI0Meta } from "/app/pages/dashboard/activities/form.vue?macro=true";
import { default as indexpba0GVeomWMykoOF6_45_45SjZ_45gJI7rbtZg7nv84QcggGkMeta } from "/app/pages/dashboard/activities/index.vue?macro=true";
import { default as _91id_93V6V1t6ZfflUtooYhn3y7mhPKhMBOQS_455nGpHxInYaMsMeta } from "/app/pages/dashboard/activities/manage/[id].vue?macro=true";
import { default as activitiesFUF0yQ9WGhwK8rOrRiJZ_fzZx0fTGMD5YeIfscQSUyIMeta } from "/app/pages/dashboard/admin/activities.vue?macro=true";
import { default as bannersPHAaC0Ye2c0ob6niMK6aiPuP6dj_45moro3pfaSnWN69kMeta } from "/app/pages/dashboard/admin/banners.vue?macro=true";
import { default as _91uuid_93wB1XLyTTh7hSOghbpZrEM_45E5N6401pi5TitEBXHZg20Meta } from "/app/pages/dashboard/admin/documentations/edit/[uuid].vue?macro=true";
import { default as documentationskwA1srsjO21LyFcGpUm8T3mxqbXiF9_45UAfZMo8jY7HAMeta } from "/app/pages/dashboard/admin/documentations.vue?macro=true";
import { default as lpjWkryvqrvpv0dvt2TYq_45XZKec9OUk9QWBHeiDyv17PZAMeta } from "/app/pages/dashboard/admin/lpj.vue?macro=true";
import { default as usersTXE9QQ5JjBQewK_l_45Qkm_pdMBXO9fC7fTopt_45BEjtjsMeta } from "/app/pages/dashboard/admin/users.vue?macro=true";
import { default as change_45passwordPD3OCsYHtlsVShl5ivQo_45koKNItRjGcNAl8mtIduHjcMeta } from "/app/pages/dashboard/change-password.vue?macro=true";
import { default as my_45activitieskRp5zpdI8X8yvXc20nM1odrHT7Nlx9IMnfYYufCx_jQMeta } from "/app/pages/dashboard/my-activities.vue?macro=true";
import { default as _91uuid_93B5Qpzg1U23u2B9Z9MNJ9lfoQZBxR6V_liMcHybHVhuwMeta } from "/app/pages/dashboard/my-documentations/[uuid].vue?macro=true";
import { default as _91uuid_93SeuhLyK3UdExxaXwn0CRP__pewn60aviOtCwuNHY_agMeta } from "/app/pages/dashboard/my-documentations/edit/[uuid].vue?macro=true";
import { default as indexZkNbwSPXfeoPVexZ_45qHzEkp_53X_45AcgvlSe9rntGHbQMeta } from "/app/pages/dashboard/my-documentations/index.vue?macro=true";
import { default as editFSptKIoZ1lCj0agCWeFSYoPeSUkzZ_45i1B_mzoQu9IJUMeta } from "/app/pages/dashboard/profile/edit.vue?macro=true";
import { default as indexHeDrCakyvPzB2ImbrGV3LJeGutMVsWJFwVFMQN0CYG4Meta } from "/app/pages/dashboard/profile/index.vue?macro=true";
import { default as dashboardMP4s_45_45Pnrs3lAogdEWxQSVgBglFzEw4XrIvkluYCTzEMeta } from "/app/pages/dashboard.vue?macro=true";
import { default as indexRalc6V3FP62DlO9Kp84mc6egYI3Q8_45kime2vPOwDMzwMeta } from "/app/pages/documentation/index.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as poster_45generatorNgbDZwysF1y8fCganXWo9wkQuEYNbKWmW_45jL_45_45JO1scMeta } from "/app/pages/poster-generator.vue?macro=true";
import { default as _91uuid_93sGGhKnt5fLHPWIBqNfhPHjC6IPb4Z9f9BKVVPaIc1NwMeta } from "/app/pages/volunteer/[uuid].vue?macro=true";
export default [
  {
    name: "activities-slug",
    path: "/activities/:slug()",
    component: () => import("/app/pages/activities/[slug].vue")
  },
  {
    name: "activities",
    path: "/activities",
    component: () => import("/app/pages/activities/index.vue")
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("/app/pages/auth.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/app/pages/dashboard.vue"),
    children: [
  {
    name: "dashboard-activities-form",
    path: "activities/form",
    component: () => import("/app/pages/dashboard/activities/form.vue")
  },
  {
    name: "dashboard-activities",
    path: "activities",
    component: () => import("/app/pages/dashboard/activities/index.vue")
  },
  {
    name: "dashboard-activities-manage-id",
    path: "activities/manage/:id()",
    component: () => import("/app/pages/dashboard/activities/manage/[id].vue")
  },
  {
    name: "dashboard-admin-activities",
    path: "admin/activities",
    component: () => import("/app/pages/dashboard/admin/activities.vue")
  },
  {
    name: "dashboard-admin-banners",
    path: "admin/banners",
    component: () => import("/app/pages/dashboard/admin/banners.vue")
  },
  {
    name: "dashboard-admin-documentations",
    path: "admin/documentations",
    component: () => import("/app/pages/dashboard/admin/documentations.vue"),
    children: [
  {
    name: "dashboard-admin-documentations-edit-uuid",
    path: "edit/:uuid()",
    component: () => import("/app/pages/dashboard/admin/documentations/edit/[uuid].vue")
  }
]
  },
  {
    name: "dashboard-admin-lpj",
    path: "admin/lpj",
    component: () => import("/app/pages/dashboard/admin/lpj.vue")
  },
  {
    name: "dashboard-admin-users",
    path: "admin/users",
    component: () => import("/app/pages/dashboard/admin/users.vue")
  },
  {
    name: "dashboard-change-password",
    path: "change-password",
    component: () => import("/app/pages/dashboard/change-password.vue")
  },
  {
    name: "dashboard-my-activities",
    path: "my-activities",
    component: () => import("/app/pages/dashboard/my-activities.vue")
  },
  {
    name: "dashboard-my-documentations-uuid",
    path: "my-documentations/:uuid()",
    component: () => import("/app/pages/dashboard/my-documentations/[uuid].vue")
  },
  {
    name: "dashboard-my-documentations-edit-uuid",
    path: "my-documentations/edit/:uuid()",
    component: () => import("/app/pages/dashboard/my-documentations/edit/[uuid].vue")
  },
  {
    name: "dashboard-my-documentations",
    path: "my-documentations",
    component: () => import("/app/pages/dashboard/my-documentations/index.vue")
  },
  {
    name: "dashboard-profile-edit",
    path: "profile/edit",
    component: () => import("/app/pages/dashboard/profile/edit.vue")
  },
  {
    name: "dashboard-profile",
    path: "profile",
    component: () => import("/app/pages/dashboard/profile/index.vue")
  }
]
  },
  {
    name: "documentation",
    path: "/documentation",
    component: () => import("/app/pages/documentation/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "poster-generator",
    path: "/poster-generator",
    component: () => import("/app/pages/poster-generator.vue")
  },
  {
    name: "volunteer-uuid",
    path: "/volunteer/:uuid()",
    component: () => import("/app/pages/volunteer/[uuid].vue")
  }
]